// ============================================================================
// MERGE SORT - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'merge-sort',
  name: 'Merge Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n log n)',
    space: 'O(n)'
  },
  description: 'A divide-and-conquer sorting algorithm that divides the input array into two halves, recursively sorts them, and then merges the two sorted halves back together. It guarantees O(n log n) time complexity in all cases.'
};
